let selector = '.breakpoint-detection';
let elems = Array.prototype.slice.call(
  document.querySelectorAll( selector )
);
let cache = null;

// Clear out the cache if the window resizes at all
window.addEventListener( 'resize', function() {
  cache = null;
});

/**
 * Returns a string of the currently active breakpoint
 * @return {String} - small, medium, large
 */
export function getBreakpoint() {
  if ( cache !== null ) {
    return cache;
  }

  return cache = ( elems.filter( function( elem ) {
    let style = window.getComputedStyle( elem );
    return style.visibility === 'visible';
  })[ 0 ].dataset.breakpoint );

}
